import { activityCategoryLabels } from "@sp-crm/core";
import type { AppRouter } from "@sp-crm/server/rpc";
import type { inferRouterOutputs } from "@trpc/server";
import React from "react";
import { Link } from "react-router-dom";
import { formatGoalMetricItemDate, goalMetricItemHref } from "./goal-metric-item";

type RecentActivity = inferRouterOutputs<AppRouter>["marketingGoal"]["recentActivity"];

interface RecentActivityListProps {
    recent: RecentActivity;
}

export const RecentActivityList: React.FC<RecentActivityListProps> = ({ recent }) => (
    <section>
        <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
            Recent activity feeding goals
        </div>
        {recent.length === 0 ? (
            <div className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 text-center text-sm text-gray-600">
                No completed visits or outreach recorded for this month.
            </div>
        ) : (
            <div className="divide-y divide-gray-100 rounded-lg ring-1 ring-gray-200">
                {recent.map(activity => (
                    <div
                        key={activity.id}
                        className="flex items-center gap-2.5 px-4 py-2.5">
                        <span className="text-sm font-medium text-gray-900">
                            {activityCategoryLabels[activity.category]}
                        </span>
                        {activity.redaction === "otherOffice" ? (
                            <span className="truncate text-xs italic text-gray-500">
                                In another office
                            </span>
                        ) : activity.parentName ? (
                            activity.link ? (
                                <Link
                                    to={goalMetricItemHref(activity.link)}
                                    className="truncate text-xs text-brand-700 hover:underline">
                                    {activity.parentName}
                                </Link>
                            ) : (
                                <span className="truncate text-xs text-gray-500">
                                    {activity.parentName}
                                </span>
                            )
                        ) : null}
                        <span className="ml-auto whitespace-nowrap text-xs text-gray-500">
                            {formatGoalMetricItemDate(activity.date)}
                        </span>
                    </div>
                ))}
            </div>
        )}
    </section>
);
